<template>
  <div class="container">
    <wrap-container>
      <p>
        Te vamos a llamar para confimar la solicitud al número ingresado, si no
        es correcto, te pedimos que lo modifiques.
      </p>
      <p>
        <strong :data-obfuscate="quantumObfuscate"
          >{{ value.normalizado.area }} {{ value.normalizado.caracteristica }}
          {{ value.normalizado.nro }}</strong
        >
      </p>
      <custom-link
        class="custom-link"
        label="Modificar"
        @click.native="showModal = true"
        analyticsName="modificar celular"
      />
    </wrap-container>
    <change-phone
      :show="showModal"
      @close="showModal = false"
      v-model="value"
      analyticsSubmodule="modificar celular"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import CustomLink from "@/components/core/CustomLink";
import ChangePhone from "@/components/core/modals/ChangePhone";
export default {
  name: "PhoneData",
  components: { WrapContainer, CustomLink, ChangePhone },
  props: {
    value: Object,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style scoped>
p {
  font-size: 14px;
  line-height: 24px;
}
</style>
